const padBase = 8;

export const APP_HEADER = {
  height: '60px',
  // background: '#000066',
  background: '#5b5bad',
  padding: `${padBase * 3}px`,
};
